/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react'
import { useThree } from '@react-three/fiber';
import { useDispatch } from 'react-redux';

import { const_var, params } from '../../redux/reducers/reducer';
import { handleCloseforDoorWindows, handleMobileDraw } from '../../action';

import CenterBuilding from './CenterBuilding';
import LeanTo from './LeanTo';
import Cupolas from './Cupolas';
import Measurements from './Measurements';
import WallName from './WallName';
import Background from './Background';
import { makeTranslucent } from '../../redux/reducers/utils';
import { controls } from '../../redux/reducers/eventReducer';

const Building = () => {    
    const { scene, camera, gl } = useThree();    
    
    const dispatch = useDispatch()

    // if(controls.isCheckActiveTab != null && controls.isCheckActiveTab == "doorwindow"){
    //     setTimeout(() => {
    //         makeTranslucent(controls.isCheckActiveTab,params.activeWall,params.is_translusant,scene);
    //     }, 700);
    // }

    const handleResize = () => {
        setTimeout(() => {
            dispatch(handleCloseforDoorWindows(1));
            let classData = document.getElementsByClassName("building-size");
            console.log(classData,"classData",classData[0].clientWidth ,classData[0].clientHeight)
            camera.aspect = classData[0].clientWidth / classData[0].clientHeight;
            camera.updateProjectionMatrix();
            gl.setSize(classData[0].clientWidth, classData[0].clientHeight);
        }, 700);
    };

    useEffect(() => {
        if(controls.isCheckActiveTab != null && controls.isCheckActiveTab == "doorwindow"){
            makeTranslucent(controls.isCheckActiveTab,params.activeWall,params.is_translusant,scene);
        }
    }, [controls.isCheckActiveTab, params.activeWall, params.is_translusant, scene, handleResize])
    
    useEffect(() => {
        const_var.scene = scene
        const_var.camera = camera
        const_var.camera.castShadow = true
        const_var.renderer = gl
   
        handleResize();
        if(window.innerWidth<993){
            dispatch(handleMobileDraw(false))
        }
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
        
    }, [scene, camera, gl, window.innerWidth]);
    
    return (
        <>
            <group name='center'>
                <CenterBuilding/>
            </group>
            <LeanTo />
            {/* {const_var.cupolas.length > 0 && <Cupolas />} */}
            {/* <group name='Measurements-main'>
                <Measurements />
            </group> */}
            <WallName />
            <Background />
        </>
    )
}

export default Building
